/* eslint-disable */
import api from '@/utils/backend-api'

export default {
  namespaced: true,
  state: {
    // modules: '',
    polices:'',
    singlepolice:'',
  },
  mutations: {
    setPolicesData (state, {polices}) {
      state.polices = polices
    },
    setSinglePoliceData (state, {polices}) {
      state.singlepolice = polices
    },
  reset(state){
    state.polices=''
    state.singlepolice=''

  }
  },

  actions: {
    setPolicesData({commit},data){
      commit('setPolicesData', {data})
    },
    getAllPolices({commit}) {
      console.log("ok")
      return new Promise(function (resolve, reject) {
        api.getData('driver/viewPoliceStation')
        .then((response) => {
          console.log("ok")
          var polices = response.data
          commit('setPolicesData', {polices})
          resolve(polices)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // getClassDetails(id){
    //   return new Promise(function (resolve, reject) {
    //     api.getData('admin/module/'+id)
    //     .then((response) => {
    //       var modules = response.data
    //       commit('setModulesData', {modules})
    //       resolve(modules)
    //     }).catch((error) => {
    //       reject(error)
    //     })
    //   })
    // },

    AddPolice ({commit}, PoliceDetails) {
      console.log("okkkkkkk")
      return new Promise(function (resolve, reject) {
        const config = {
          headers: {
              'content-type': 'multipart/form-data'
          }
        }
        api.postData('driver/createPoliceStation', PoliceDetails,config).then(res => {
          commit('setPolicesData', res.Data)
          dispatch("police/getAllPolices")
          resolve(res.Data)
        }).catch((error) => {
          reject(error)
        })
        .then(() => {
        })
      })
    },


    classEdit({commit}, Data) {
      let PoliceDetails=Data.policeDetails

      return new Promise(function (resolve, reject) {
        api.postData('admin/module/' + Data.adminId, PoliceDetails).then(res => {
          commit('setModulesData', res.Data)
          resolve(res.Data)
        }).catch((error) => {
          reject(error)
        })
        .then(() => {
        })
      })
    },
    getPoliceById ({ commit }, id) {
      // commit('setLoading', { loading: true })
      if (id) {
        // api.getData('driver/updatePoliceStation/' + id).then(
        //       res => {
        //         const polices = res.data
        //         commit('setSinglePoliceData', { polices })
        //       },
        //       err => {
        //       }
        //   )
      }
    },

    
    deletePoliceById ({ commit }, id) {
      // commit('setLoading', { loading: true })
      if (id) {
        api.postData('driver/deletePoliceStation/' + id).then(
              res => {
                const polices = res.data
                commit('setPolicesData', { polices })
              },
              err => {
              }
          )
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/polices.js